import styles from './index.module.sass';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const Button = ({ disabled = false, onClick, children, theme }) => {
  const className = cx({
    button: true,
    disabled,
    [theme]: true,
  });
  return (
    <button type="button" className={className} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
